import { loadRemoteModule, registerExternalGetter } from '@meego/remote-loader';
// import { getIsInGreyWithProjkey } from '@meego/models/src/query/fg';
// import { FeatureGateKeys } from '@meego/models/src/types/featureGateKeys';

// const externalGetterMap: {
//   [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
// } = {
//   /**
//    * 业务模块
//    */
//   '@meego-progressive/onboarding/help/components': [
//     () => loadRemoteModule('@meego-progressive/onboarding', './help/components'),
//     [],
//   ],
//   '@meego-progressive/onboarding/help': [
//     () => loadRemoteModule('@meego-progressive/onboarding', './help'),
//     [],
//   ],
//   '@meego-progressive/onboarding/guide/concept': [
//     () => loadRemoteModule('@meego-progressive/onboarding', './guide/concept'),
//     [],
//   ],
//   '@meego-progressive/onboarding/guide/task': [
//     () => loadRemoteModule('@meego-progressive/onboarding', './guide/task'),
//     [],
//   ],
//   '@meego-progressive/onboarding/trial/pages': [
//     () => loadRemoteModule('@meego-progressive/onboarding', './trial/pages'),
//     [],
//   ],
//   '@meego-progressive/onboarding/models/api': [() => import('./onboarding/models/api')],
//   '@meego-progressive/onboarding/models/types': [() => import('./onboarding/models/types')],
// };

// TODO：灰度去掉之后，把引用的 key 也改掉
const externalRemoteGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {
  /**
   * 业务模块
   */
  '@meego-progressive/onboarding/help/components': [
    () => loadRemoteModule('@meego-remote/onboarding', './help/components'),
    [],
  ],
  '@meego-progressive/onboarding/help': [
    () => loadRemoteModule('@meego-remote/onboarding', './help'),
    [],
  ],
  '@meego-progressive/onboarding/guide/concept': [
    () => loadRemoteModule('@meego-remote/onboarding', './guide/concept'),
    [],
  ],
  '@meego-progressive/onboarding/guide/task': [
    () => loadRemoteModule('@meego-remote/onboarding', './guide/task'),
    [],
  ],
  '@meego-progressive/onboarding/trial/pages': [
    () => loadRemoteModule('@meego-remote/onboarding', './trial/pages'),
    [],
  ],
  '@meego-progressive/onboarding/utils': [
    () => loadRemoteModule('@meego-remote/onboarding', './utils'),
    [],
  ],
  '@meego-progressive/onboarding/operationProcessor': [
    () => loadRemoteModule('@meego-remote/onboarding', './guide/operationProcessor'),
  ],
  '@meego-progressive/onboarding/models/api': [() => import('./onboarding/models/api')],
  '@meego-progressive/onboarding/models/types': [() => import('./onboarding/models/types')],
};

// 依赖声明
// export const onboardingCommonDeps = [
//   /**
//    * 基座能力部分
//    */
//   '@meego-progressive/base/i18next',
//   '@meego-progressive/base/monitors',
//   '@meego-progressive/base/apiService',
//   '@meego-progressive/base/fg',
//   '@meego-progressive/base/store',
//   '@meego-progressive/base/router',
//   '@meego-progressive/base/tools',
//   '@meego-progressive/base/diagnose',
//   '@meego-progressive/base/webStorage',
//   '@meego-progressive/base/constants/featureGateKeys',
//   '@meego-progressive/platform/user',
//   /**
//    * 工具函数部分
//    */
//   '@meego-progressive/utils',
//   '@meego-progressive/meego-components',
//   '@meego-progressive/biz-components',
//   /** onboarding 业务相关 */
//   '@meego-progressive/onboarding/models/api',
//   '@meego-progressive/onboarding/models/types',
// ];

// 声明 @meego-remote/onboarding/deps 这个 preset 方便使用，上面 externalGetterMap 中也可以手动定义依赖模块
// externalGetterMap['@meego-remote/onboarding/common-deps'] = [
//   () => Promise.resolve(),
//   onboardingCommonDeps,
// ];

// 声明 @meego-remote/onboarding/deps 这个 preset 方便使用，上面 externalGetterMap 中也可以手动定义依赖模块
// externalRemoteGetterMap['@meego-remote/onboarding/common-deps'] = [
//   () => Promise.resolve(),
//   onboardingCommonDeps,
// ];

const init = () => {
  Object.entries(externalRemoteGetterMap).forEach(([name, [getter, dependencies]]) =>
    registerExternalGetter(name, getter, dependencies),
  );
};

export { init };
